module.exports = __webpack_public_path__ + "static/img/bcg.e25796f4.jpg";